import sendRequest from "./sendRequest";

export const ping = () => {
    return sendRequest("/ping", "GET", false);
}

export const ping_auth = () => {
    return sendRequest("/ping_auth", 'GET');
}
